var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main hyundai"},[_c('Slider'),_c('Match'),_c('Video'),_c('Feeds'),_c('Shop'),_c('Application'),_c('Sponsor'),_c('LayerPopup')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }